import React from 'react';
import { Modal as AntdModal, Spin } from 'antd';
import classNames from 'classnames';
import styles from './Modal.module.scss';
function Modal({
  children,
  centered = true,
  title = '',
  onCancel,
  onOk,
  showFooter = false,
  contentClassName = '',
  cancelText = '取消',
  okText = '确认',
  loadingStatus = false,
  okDisabled = false,
  className,
  ...props
}) {
  return (
    <AntdModal
      centered={centered}
      className={classNames(styles.box, className)}
      footer={
        showFooter ? (
          <div className={styles.modalFooter}>
            {cancelText && (
              <button
                className={`${styles.modalBtn} ${styles.cancelBtn}`}
                onClick={onCancel}
              >
                {cancelText}
              </button>
            )}

            <Spin spinning={loadingStatus}>
              <button
                className={`${styles.modalBtn} ${styles.confirmBtn}`}
                onClick={onOk}
                disabled={okDisabled}
              >
                {okText}
              </button>
            </Spin>
          </div>
        ) : null
      }
      destroyOnHidden={true}
      onCancel={onCancel}
      {...props}
    >
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={contentClassName}>{children}</div>
      </div>
    </AntdModal>
  );
}

export default Modal;
